<template>
  <div class="guide Guide">
    <SubSectionBanner :subSectionData="subSectionData" />
    <section id="servicios" class="secciones seccion-blanca formulario">
      <div class="container">
        <SubSectionStandartHead :subSectionData="subSectionData" />
        <br />
        <br />
        <div class="bloque">
          <div id="accordion" class="acordeon">
            <div class="card card-guide" v-for="(item, index) in item_list" :key="index">
              <div class="card-header" :id="'heading' + index">
                <button
                  :class="
                    (index == 0 && id_guide_url == '') || index == id_guide_url
                      ? 'btn btn-link'
                      : 'btn btn-link collapsed'
                  "
                  data-toggle="collapse"
                  :data-target="'#collapse' + index"
                  aria-expanded="true"
                  :aria-controls="'#collapse' + index"
                >
                  <h5 class="mb-0">{{ item.title_item_es }}</h5>
                  <span class="material-icons">expand_less</span>
                </button>
              </div>

              <div
                :id="'collapse' + index"
                :class="
                  (index == 0 && id_guide_url == '') || index == id_guide_url
                    ? 'collapse show'
                    : 'collapse'
                "
                :aria-labelledby="'#heading' + index"
                data-parent="#accordion"
              >
                <div class="card-body">
                  <span v-html="item.desc_item_es"></span>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
        </div>
      </div>
    </section>
    <TwoModules></TwoModules>
    <News></News>
  </div>
</template>

<script>
import SubSectionBanner from '@/views/components/SubSectionBanner';
import SubSectionStandartHead from '@/views/components/SubSectionStandartHead';
import TwoModules from '@/components/products/TwoModules.vue';
import News from '@/components/products/Guia.vue';
import axios from 'axios';
import { config_settings } from '@/config.js';

export default {
  components: {
    SubSectionBanner,
    SubSectionStandartHead,
    TwoModules,
    News,
  },
  props: ['subSectionData'],
  data() {
    return {
      imgPreUrl: config_settings.PHOTO_SERVER_URL + '/',
      cod_sub_sec: this.subSectionData.cod_sub_section,
      item_list: [],
      id_guide_url: this.$route.params.id,
    };
  },

  methods: {
    getItems() {
      axios
        .get(
          config_settings.RESOURCE_SERVER_URL +
            '/GET/sub_sections/' +
            this.cod_sub_sec +
            '/items_all',
        )
        .then((response) => {
          this.item_list = response.data;
          console.log(JSON.stringify(response.data));
          this.validacion_url();
        })
        .catch((error) => {
          console.log('error');
        });
    },

    scrollToTop() {
      window.scrollTo(0, 0);
    },

    scrollToLink(number) {
      var subir = 800 + number * 30;
      window.scrollTo(0, subir);
    },

    validacion_url() {
      if (this.id_guide_url != '') {
        this.scrollToLink(this.id_guide_url);
      }
    },
  },

  created() {
    this.scrollToTop();
    this.getItems();
  },
};
</script>

<style lang="scss" src="./Guide.scss"></style>
